import { Button, createStyles, Group, LoadingOverlay } from '@mantine/core'
import { IconCheck, type Icon } from '@tabler/icons-react'
import { type FC, type FormEvent, type FormHTMLAttributes, type ReactNode } from 'react'

const useStyles = createStyles({
  form: {
    position: 'relative'
  }
})

export interface FormProps extends FormHTMLAttributes<HTMLFormElement> {
  buttonLabel?: ReactNode
  ButtonIcon?: Icon
  buttons?: ReactNode
  isSaving?: boolean
  isValid?: boolean
  onSubmit: (event: FormEvent<HTMLFormElement>) => void
}

export const Form: FC<FormProps> = ({
  buttonLabel = 'Save',
  ButtonIcon = IconCheck,
  buttons,
  children,
  className,
  isSaving = false,
  isValid = true,
  onSubmit,
  ...props
}) => {
  const { classes, cx } = useStyles()

  return (
    <form
      className={cx(classes.form, className)}
      onSubmit={onSubmit}
      {...props}
    >
      <LoadingOverlay visible={isSaving} />
      {children}
      {buttons || (
        <Group
          mt='xl'
          position='right'
        >
          <Button
            disabled={isSaving || !isValid}
            leftIcon={<ButtonIcon size={18} />}
            loading={isSaving}
            type='submit'
          >
            {buttonLabel}
          </Button>
        </Group>
      )}
    </form>
  )
}
